/**
 * This function converts css string to css object
 * For example, you want to use any mixin from ui-kit, which is string:
 *       fontButtonXS: `
 *          font-size: ${typographyFontSizes.fontSizeXS};
 *          line-height: 1.2;
 *          font-weight: 600;
 *        `,
 *
 *        ===> You should use this code:
 *       ...cssToObject(defaultTheme.theme.mixin.fontButtonXS),
 **/

export  const cssToObject = (css: string) => {
    const cssSplit = css.replace(/\n/g, '').split(';');
    const cssObj: { [index: string]: string } = {};
    for (const o of cssSplit) {
        const oNormal = o.trim();
        if (oNormal === '') continue;
        const [p, v] = oNormal.split(':');
        cssObj[p.trim()] = v.trim();
    }
    return cssObj;
};
